import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, rem, breakpoints, utilityStyles } from '../../../../styles';
import StyledTileDivider from '../../styles/tile.divider.styles';
import StyledTileInner from '../../styles/tile.inner.styles';
import StyledTileOuter from '../../styles/tile.outer.styles';
import StyledTileLabel from '../../styles/tile.label.styles';
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("padding:", rem(16), ";", StyledTileOuter, "{align-items:flex-start;}", StyledTileLabel, "{margin-bottom:", rem(8), ";margin-top:", rem(8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var variantStyles = function variantStyles(_ref2) {
  var variant = _ref2.variant;
  switch (variant) {
    case 'gray':
      return /*#__PURE__*/css("background-color:", colors.coolGray_100, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'cool-gray':
      return /*#__PURE__*/css("background-color:", colors.coolGray_200, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'white':
      return /*#__PURE__*/css("background-color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'dark':
      return /*#__PURE__*/css("background-color:", colors.navy_500, ";color:", colors.white, ";&+", StyledTileDivider, "{background-color:", colors.navy_500, ";>div{border-top-color:", colors.navy_300, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'brand':
      return /*#__PURE__*/css("background-color:", colors.blue_500, ";color:", colors.white, ";&+", StyledTileDivider, "{background-color:", colors.blue_500, ";>div{border-top-color:", colors.blue_400, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'transparent':
      return /*#__PURE__*/css("box-shadow:none;background-color:", colors.transparent, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var densityStyles = function densityStyles(_ref3) {
  var density = _ref3.density;
  if (density === 'compact') {
    return /*#__PURE__*/css("padding:", rem(8, 16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
  } else {
    return /*#__PURE__*/css("padding:", rem(16), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:densityStyles;"));
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : {
  name: "16i5xo9-isFlushStyles",
  styles: "padding:0;label:isFlushStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var isFlushStyles = function isFlushStyles(_ref4) {
  var isFlush = _ref4.isFlush;
  if (isFlush === true) {
    return _ref;
  }
};
var responsiveStyles = function responsiveStyles(_ref5) {
  var containersize = _ref5.containersize;
  if (containersize && containersize.width > breakpoints.md[0]) {
    return /*#__PURE__*/css("margin:0;", StyledTileInner, "{align-items:center;flex-direction:row;", StyledTileLabel, "{margin-bottom:", rem(8), ";margin-top:0;span{margin-left:0;}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:responsiveStyles;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledTileHead = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eeb8hdf0"
} : {
  target: "eeb8hdf0",
  label: "StyledTileHead"
})(resetStyles, defaultStyles, variantStyles, densityStyles, isFlushStyles, responsiveStyles, utilityStyles);
export default StyledTileHead;